import client from "../../../api/client";

export default async function getNationalities() {
  const response = await client.get("/master/nationalities");
  return response.data;
}